import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNextDisable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .3,
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.24715 25.1253L18.3752 17.1633C18.657 16.9175 18.6862 16.4898 18.4404 16.208C18.4206 16.1854 18.3994 16.1641 18.3768 16.1442L9.24874 8.1321C8.9677 7.88542 8.5399 7.91327 8.29322 8.1943C8.18479 8.31784 8.125 8.47659 8.125 8.64096V24.615C8.125 24.989 8.42814 25.2921 8.80208 25.2921C8.96573 25.2921 9.12383 25.2328 9.24715 25.1253Z",
		fill: "#B4B8BF"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.3722 25.1253L26.5002 17.1633C26.782 16.9175 26.8112 16.4898 26.5654 16.208C26.5456 16.1854 26.5244 16.1641 26.5018 16.1442L17.3737 8.1321C17.0927 7.88542 16.6649 7.91327 16.4182 8.1943C16.3098 8.31784 16.25 8.47659 16.25 8.64096V24.615C16.25 24.989 16.5531 25.2921 16.9271 25.2921C17.0907 25.2921 17.2488 25.2328 17.3722 25.1253Z",
		fill: "#B4B8BF"
	})]
});
export default SvgNextDisable;
